import { Component, h } from 'preact';

import { InquiryDocument } from 'inquiries/inquiry-document.model';
import { InqOfferSentModal } from './inq-offer-sent-modal.component';
import { InquiryDocumentType } from '../../../../../constants/inquiries';
import { inquiryService } from '../../../../utils/inquiry.service';
import { Inquiry } from '../../../../../types/inquiries';
import { ReqState } from '../../../../../types/request-state.model';
import { ListResponse } from '../../../../../types/list-response.model';


interface InqOfferSentModalHostProps {
  onClose: () => void;
  inquiry: Inquiry;
  documentType: InquiryDocumentType;

  onSuccessfulUpload?: (docType: InquiryDocumentType, document: InquiryDocument) => void;
}

interface InqOfferSentModalHostState {
  uploadState?: ReqState;

  offerReqState?: ReqState;
  offerList?: ListResponse<InquiryDocument>;
}

export class InqOfferSentModalHost extends Component<InqOfferSentModalHostProps, InqOfferSentModalHostState> {
  async componentDidMount() {
    this.setState({ offerReqState: ReqState.IN_PROGRESS });

    try {
      const offerList = await inquiryService.getOfferList(this.props.inquiry.inquiryCode);
      this.setState({ offerList, offerReqState: ReqState.SUCCESS });
    } catch (err) {
      this.setState({ offerReqState: ReqState.FAILED });
    }
  }

  async onDocumentUpload(document: InquiryDocument, status: string) {
    const { inquiry, documentType } = this.props;
    if (documentType === InquiryDocumentType.OFFER) {
      try {
        this.setState({ uploadState: ReqState.IN_PROGRESS });
        await inquiryService.markOfferAsSent(inquiry.inquiryCode, document.loiKey, status);
        this.setState({ uploadState: ReqState.SUCCESS });
      } catch (err) {
        this.setState({ uploadState: ReqState.FAILED });
      }
    }
  }

  render(props: InqOfferSentModalHostProps, state: InqOfferSentModalHostState) {
    const documentChoices = state.offerReqState === ReqState.SUCCESS ? state.offerList.results : null;

    return (
      <InqOfferSentModal onClose={ props.onClose }
        documentChoices={ documentChoices }
        offerReqState={ state.offerReqState }

        onUploadClick={ (document, status) => this.onDocumentUpload(document, status) }
        submitState={ state.uploadState } />
    );
  }
}
